import type { PropsWithChildren } from "react";

export const MenuContent = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex flex-1 justify-around py-10">
      <div className="flex w-3/4 gap-8">{children}</div>
    </div>
  );
};
